<svelte:options
  customElement={{
    tag: "oc-divider-v1",
    /*                       */
    extend: window.__components.extend(),
    props: {
      variant: { type: "String" },
      orientation: { type: "String", reflect: true },
      inFlow: { type: "Boolean", attribute: "in-flow", reflect: true },
    },
  }}
/>

<script lang="ts">
  import type { Props } from "./DividerV1.types.js";
  import DefaultStyles from "../../../common/components/DefaultStyles/DefaultStyles.svelte";

  let { orientation = "horizontal", inFlow = false, variant = "solid" }: Props = $props();
</script>

<div
  class="divider"
  class:divider--in-flow={inFlow}
  class:divider--vertical={orientation === "vertical"}
  style:--border-style={variant}
></div>

<DefaultStyles />

<style lang="scss" global>
  @use "@otto-ec/design-tokens/component" as tokens;
  @use "@otto-ec/otto-components-utils/scss/mixins";

  :host {
    --border-style: unset;
    position: relative;
    display: block;
    width: inherit;
  }

  :host([orientation="vertical"]) {
    height: inherit;
  }

  .divider {
    position: absolute;
    display: block;
    left: 0;
    width: 100%;
    border-top: 1px var(--border-style) tokens.$oc-component-divider-border-color;
    transform: translateY(-0.5px);

    &--in-flow {
      position: relative;
    }

    &--vertical {
      left: unset;
      top: 0;
      width: 0;
      height: 100%;
      border-left: 1px var(--border-style) tokens.$oc-component-divider-border-color;
      transform: translateX(-0.5px);
    }
  }
</style>
